import { Badge } from "../../components/ui";
import { useConfig } from "../../lib/config";
import { formatDateTime } from "../../lib/format";
import type { DueApprovalState, OrderSummary, ProductionStatus } from "./types";

const statusTone: Record<ProductionStatus, "neutral" | "brand" | "ok" | "warn" | "danger"> = {
  submitted: "neutral",
  received: "brand",
  in_production: "brand",
  ready: "ok",
  completed: "ok",
  cancelled: "danger",
};

export const STATUS_LABEL: Record<ProductionStatus, string> = {
  submitted: "Submitted",
  received: "Received",
  in_production: "In Production",
  ready: "Ready",
  completed: "Completed",
  cancelled: "Cancelled",
};

export function StatusBadge({ status }: { status: ProductionStatus }) {
  return <Badge tone={statusTone[status]}>{STATUS_LABEL[status]}</Badge>;
}

const dueLabels: Record<
  DueApprovalState,
  { label: string; tone: "neutral" | "ok" | "warn" | "danger" }
> = {
  requested: { label: "Requested", tone: "neutral" },
  confirmed: { label: "Confirmed", tone: "ok" },
  revision_proposed: { label: "New date proposed", tone: "warn" },
  revision_accepted: { label: "Confirmed", tone: "ok" },
  revision_rejected: { label: "New date declined", tone: "danger" },
};

export function DueBadge({ state }: { state: DueApprovalState }) {
  const d = dueLabels[state];
  return <Badge tone={d.tone}>{d.label}</Badge>;
}

export function DueText({ order }: { order: Pick<OrderSummary, "effective_due_at"> }) {
  const { data } = useConfig();
  const tz = data?.business_timezone ?? "UTC";
  return <span>{formatDateTime(order.effective_due_at, tz)}</span>;
}
